import { BaseService } from "services/_baseService";

class ReviewsAdminService extends BaseService<any> {
  constructor() {
    super(`reviews`);
  }
}

export default new ReviewsAdminService();
